<template>
  <div class="page-content">
    <AttendancePagesHeading
      pageName="Gas-Bill"
      :date="date"
      @filterSearch="filterSearch"
      @changeDate="changeDate"
    ></AttendancePagesHeading>

    <div class="card">
      <div class="card-body">
        <div class="button-area mb-2" style="float: right">
          <button
            v-if="approveLoading"
            class="btn btn-primary"
            type="button"
            disabled
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
          <button
            v-else
            class="btn btn-primary"
            :disabled="!noOfCheckedBills"
            @click="approveCheckedBills()"
          >
            Approve
          </button>
        </div>
        <DefaultLoader v-if="isLoading"></DefaultLoader>
        <div v-else class="table-responsive" style="width: 100%">
          <table class="table partner-table">
            <thead style="height: 45px">
              <tr>
                <th>#</th>
                <th>Driver Name</th>
                <th>Owner Name</th>
                <th>Owner Bank</th>
                <th>Owner AC No.</th>
                <th>Contracted Body Rent</th>
                <th>Eligible For Gas Bill</th>
                <th>Gas Bill Disbursed</th>
                <th>Disbursed Amount</th>
                <th v-if="filterValue.service_type === 'B2B'">Company Code</th>
                <th>Eligibility Status</th>
                <th>Approve Status</th>
                <th>Gas Bill Amount</th>
              </tr>
            </thead>
            <tbody class="align-middle">
              <template v-if="filterValue.modality === 'fleet-variable'">
                <template v-if="gasBillList?.length">
                  <tr v-for="(bill, index) in gasBillList" :key="index">
                    <td>
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="bill.checked"
                        :disabled="!eligibleToDisburse(bill)"
                      />
                    </td>
                    <td>
                      {{
                        driverDetailsObj[bill.driver_code]?.name
                          ? driverDetailsObj[bill.driver_code].name
                          : 'N/A'
                      }}
                    </td>
                    <td>
                      <span v-if="driverDetailsObj[bill.user_code]?.name">{{
                        driverDetailsObj[bill.user_code].name
                      }}</span>
                      <span v-else class="text-warning"
                        >Owner appears after bill</span
                      >
                    </td>
                    <td>
                      <span v-if="bill.owner_bank_name">{{
                        bill.owner_bank_name
                      }}</span>
                      <span v-else-if="bill.owner_payment_method">{{
                        bill.owner_payment_method
                      }}</span>
                      <span v-else>N/A</span>
                    </td>
                    <td>
                      {{
                        bill.owner_account_no ? bill.owner_account_no : 'N/A'
                      }}
                    </td>
                    <td>{{ bill.body_rent ? bill.body_rent : 'N/A' }}</td>
                    <td>{{ eligibleBillAmount(bill) }}</td>
                    <td>
                      {{
                        bill.gas_bill_approve_count
                          ? bill.gas_bill_approve_count
                          : 0
                      }}
                    </td>
                    <td>
                      {{ bill.gas_bill_amount ? bill.gas_bill_amount : 0 }}
                    </td>
                    <td v-if="filterValue.service_type === 'B2B'">
                      {{ bill.company_code }}
                    </td>
                    <td>
                      <span
                        v-if="eligibleToDisburse(bill)"
                        class="partner-badge partner-badge-success rounded-pill"
                        >Eligible</span
                      ><span
                        v-else
                        class="partner-badge partner-badge-pink rounded-pill"
                        >Ineligible</span
                      >
                    </td>
                    <td>
                      <span
                        v-if="bill.approve_status"
                        class="partner-badge partner-badge-primary rounded-pill"
                        >{{ bill.approve_status }}</span
                      >
                      <span
                        v-else
                        class="partner-badge partner-badge-pink rounded-pill"
                        >pending</span
                      >
                    </td>
                    <td>
                      <input
                        type="number"
                        style="max-width: 110px"
                        v-model="bill.input_amount"
                        :disabled="!eligibleToDisburse(bill)"
                      />
                    </td>
                  </tr>
                </template>
                <tr v-else>
                  <td colspan="50" class="text-center text-danger">
                    No data found!
                  </td>
                </tr>
              </template>
              <tr v-else>
                <td colspan="50" class="text-center text-danger">
                  Please choose Fleet Variable first
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@vuepic/vue-datepicker/dist/main.css';
import http from '../../config/axios';
import userServiceAPI from '../../store/userServiceAPI';
import AttendancePagesHeading from '../attendancePages/AttendancePagesHeading.vue';

export default {
  components: {
    AttendancePagesHeading
  },
  data() {
    return {
      date: null,
      filterValue: {
        service_type: localStorage.getItem('serviceType'),
        modality: localStorage.getItem('modality')
      },
      isLoading: false,
      approveLoading: false,
      gasBillList: [],
      driverDetailsObj: {},
      tzoffset: new Date().getTimezoneOffset() * 60000
    };
  },
  mounted() {
    // this.getGasBillList();
  },
  computed: {
    noOfCheckedBills() {
      let numOfCheckedBills = 0;

      this.gasBillList.forEach((bill) => {
        if (bill.checked) {
          numOfCheckedBills++;
        }
      });

      return numOfCheckedBills;
    }
  },
  watch: {
    date: {
      handler: function () {
        this.getGasBillList();
      },
      deep: true
    },
    filterValue: {
      handler: function () {
        this.getGasBillList();
      },
      deep: true
    }
  },
  methods: {
    changeDate(selectedDate) {
      this.date = selectedDate;
    },
    filterSearch(searchValues) {
      this.filterValue = {
        service_type: localStorage.getItem('serviceType'),
        modality: localStorage.getItem('modality')
      };
      for (const key in searchValues) {
        this.filterValue[key] = searchValues[key];
      }
    },
    getGasBillList(
      callback = function () {
        null;
      }
    ) {
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);

      this.isLoading = true;
      http
        .get(
          `v2/partners/bills/gas/bill/list?service_type=${this.filterValue.service_type}&start_date=${startDate}&end_date=${endDate}`
        )
        .then((response) => {
          this.gasBillList = response.data.data;

          let allUserCodes = [];
          this.gasBillList.forEach((bill) => {
            if (bill.driver_code) allUserCodes.push(bill.driver_code);
            if (bill.user_code) allUserCodes.push(bill.user_code);
          });
          userServiceAPI
            .getUserDetails(allUserCodes)
            .then((res) => {
              this.isLoading = false;
              this.driverDetailsObj = {};
              this.driverDetailsObj = userServiceAPI.mapUsersIntoObject(
                res.data?.data
              );
              callback();
            })
            .catch(() => {
              this.isLoading = false;
            });
        })
        .catch((error) => {
          this.isLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error?.response?.data?.message
          });
        });
    },
    eligibleToDisburse(bill) {
      return (
        ((bill.no_of_trips >= 10 && !bill.gas_bill_approve_count) ||
          (bill.no_of_trips >= 20 && bill.gas_bill_approve_count === 1)) &&
        (!bill.gas_bill_amount ||
          bill.gas_bill_amount < (bill.body_rent ? bill.body_rent / 2 : 0))
      );
    },
    eligibleBillAmount(bill) {
      let amount = bill.body_rent ? bill.body_rent / 2 : 0;
      if (bill.gas_bill_amount) {
        amount -= bill.gas_bill_amount;
      }
      return amount;
    },
    approveCheckedBills() {
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);

      let amountFieldsAreValid = true;
      let formValue = [];

      this.gasBillList.forEach((bill) => {
        if (bill.checked) {
          if (
            bill.input_amount &&
            bill.input_amount <= this.eligibleBillAmount(bill) &&
            this.eligibleToDisburse(bill)
          ) {
            formValue.push({
              driver_code: bill.driver_code,
              trip_request_routes_id: bill.trip_request_routes_id,
              start_date: startDate,
              end_date: endDate,
              service_type: this.filterValue.service_type,
              amount: bill.input_amount,
              company_code: bill.company_code,
              approve_count: bill.gas_bill_approve_count
                ? bill.gas_bill_approve_count
                : 0
            });
          } else {
            amountFieldsAreValid = false;
          }
        }
      });

      if (amountFieldsAreValid) {
        this.approveLoading = true;
        http
          .put('v2/partners/bills/update/gas/bill', formValue)
          .then((response) => {
            this.getGasBillList(() => {
              this.approveLoading = false;
            });
            this.$partnerSwal.quickSuccessAlert.fire({
              title: 'Success!',
              text: response.data?.message
            });
          })
          .catch((error) => {
            this.approveLoading = false;
            this.$partnerSwal.errorToast.fire({
              title: 'Error!',
              text: error?.response?.data?.message
            });
          });
      } else {
        this.$partnerSwal.warningToast.fire({
          title: 'Warning!',
          text: 'Please make sure the gas bill amount fields are valid.'
        });
      }
    }
  }
};
</script>